import React from "react";

export default function PartnersPage() {
  return (
    <div className="min-h-screen flex flex-col items-center justify-center bg-gradient-to-br from-indigo-100 via-purple-100 to-pink-100">
      <div className="max-w-3xl mx-auto py-16 px-4">
        <h1 className="text-4xl font-bold mb-4 text-gradient bg-gradient-to-r from-indigo-500 via-pink-500 to-purple-500 bg-clip-text text-transparent">Partners</h1>
        <p className="text-lg text-gray-700 mb-6">We collaborate with industry leaders, technology providers, and creative communities to deliver the best AI-powered image generation experience.</p>
        <h2 className="text-2xl font-semibold mt-8 mb-2">Our Partners</h2>
        <ul className="list-disc pl-6 text-gray-600 mb-4">
          <li>OpenAI</li>
          <li>Stability AI</li>
          <li>Unsplash</li>
          <li>Creative Commons</li>
        </ul>
        <h2 className="text-2xl font-semibold mt-8 mb-2">Become a Partner</h2>
        <p className="text-gray-600">Interested in partnering with us? <a href="/contact" className="text-indigo-600 underline">Contact us</a> to explore collaboration opportunities.</p>
      </div>
    </div>
  )
}
